import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";

import {useBacameterStore} from "@/store/models/bacameter-store";
//import {useFormaterStore} from "@/store/utility/formatter-store";

export const usePemakaianNolStore = defineStore(
    'pemakaianNolStore',
    () => {
        const isLoading = ref(false);
        const datasourcePemakaianNol = ref(
            new DataSource({
                requireTotalCount: true,
                store: useBacameterStore().pemakaianNolCustomStore,
                /*onLoadingChanged: (isLoading) => {
                    isLoading.value = isLoading;
                }*/
            })
        );

        const onMuatButtonClick =()=>{
            datasourcePemakaianNol.value.reload();
        };

        const initialized = ()=>{
            datasourcePemakaianNol.value.reload();
        };

        return {
            datasourcePemakaianNol,
            isLoading,
            onMuatButtonClick,
            initialized

        }
    }
);